import get from "lodash-es/get";

const LIST_OF_INPUT_TAGS = [
    ".form-sections",
    ".form-section",
    ".should-save",
    "input-default",
    "input-autocomplete",
    "input-time",
    "input-date",
    "input-simple",
    "input-simple-icon",
    "input-checkbox",
    "input-checkbox-list",
    "input-radio",
    "input-radiobox",
    "input-radio-icons",
    "input-image-dropzone",
    "input-select",
    "input-textarea",
    "rich-editor"
];

const findChildInputs = (sections, formElements) => {
    sections.forEach(function (section) {
        // If slotted element
        // TODO how to check this correctly?
        if (!section.shadowRoot) {
            section.assignedNodes().forEach(node => {
                if (node.nodeType !== 3) {
                    findChildInputs([node], formElements);
                }
            });
            return;
        }

        const sectionElements = Array.prototype.slice.call(
            section.shadowRoot.querySelectorAll("input, select, textarea")
        );
        Array.prototype.forEach.call(sectionElements, function (element) {
            // Can this element be skipped?
            if (section.getAttribute("data-name") === "id" && !element.value) {
                //skip element
            } else {
                formElements.push(element);
            }
        });

        const sectionChildren = section.shadowRoot.querySelectorAll(LIST_OF_INPUT_TAGS.join(","));
        if (sectionChildren && sectionChildren.length > 0) {
            sectionChildren.forEach(function (sectionChild) {
                findChildInputs([sectionChild], formElements);
            });
        }
    });

    return formElements;
};

export const getFormElements = container => {
    let form;
    let formSections;
    if (container.shadowRoot) {
        form = container.shadowRoot.querySelector("form");
        formSections = container.shadowRoot.querySelectorAll(LIST_OF_INPUT_TAGS.join(","));
    } else {
        form = container.querySelector("form");
        formSections = container.querySelectorAll(LIST_OF_INPUT_TAGS.join(","));
    }
    let formElements = [];

    // Get all form elements
    if (form) {
        Array.prototype.forEach.call(form.elements, function (element) {
            formElements.push(element);
        });
    }

    const result = findChildInputs(formSections, formElements);

    return result;
};

export const clearForm = elements => {

    elements.map(element => {
        console.log(element);
        element.value = "";
    });
};

export const formToJSON = elements =>
    [].reduce.call(
        elements,
        (data, element) => {
            if (element.name) {
                if (element.hasAttribute("data-exclude-from-json")) {
                    return data;
                }
                let value = valueByInputType(element);

                setProperty(data, element.name, value);
            }
            return data;
        },
        {}
    );

export const setProperty = (object, string, value) => {
    return string.split(".").reduce((o, property, index, array) => {
        // If property contains empty array, eg exampleProperty[]
        if (property.includes("[]")) {
            let name = property.split("[]")[0];

            // Create new array if property is undefined
            if (o[name] === undefined) {
                o[name] = [];
            }

            // if last element of array and has value push value to array
            if (index === array.length - 1 && value) {
                o[name].push(value);
            }

            // get last element in array
            const l = o[name].length - 1;

            // Set property to splited name, eg: exampleProperty[] becomes exampleProperty
            property = name;
            return o[property][l];
        }
        // If property contains filled array, eg [1]
        else if (/([a-zA-Z_][a-zA-Z0-9_]*)\[([0-9]+)\]/.test(property)) {
            const matches = /([a-zA-Z_][a-zA-Z0-9_]*)\[([a-zA-Z0-9_]+)\]/.exec(property);
            const name = matches[1];
            const matchIndex = matches[2];

            // Create new array if property is undefined
            if (o[name] === undefined) {
                o[name] = [];
            }

            if (o[name][matchIndex] === undefined) {
                o[name][matchIndex] = {};
            }

            // Set property to splited name, eg: exampleProperty[] becomes exampleProperty
            property = name;

            // Return the array object insteed of the array
            return o[property][matchIndex];
        } else if (o[property] == null) {
            // Set value if property is the last in array else create empty object
            if (index === array.length - 1) {
                o[property] = value;
            } else {
                o[property] = {};
            }
            return o[property];
        } else {
            return o[property];
        }
    }, object);
};

const isHidden = elm => {
    return elm.offsetParent === null;
};

export const validateForm = formElements => {
    return formElements.every(elm => {
        // Check if element is hidden by conditions
        // Should show hidden checkboxes

        if (isHidden(elm)) {
            // todo fix this based on conditional-hidden class parent could not be found
            if (window.getComputedStyle(elm).display !== "none") {
                return true;
            }
        }

        const valid = elm.checkValidity();
        if (valid) {
            elm.removeAttribute("aria-invalid");
            return valid;
        } else {
            elm.setAttribute("aria-invalid", "true");
            elm.focus();
            return false;
        }
    });
};

const keyify = (obj, prefix = '') =>
    Object.keys(obj).reduce((res, el) => {
        if( Array.isArray(obj[el]) ) {
            return res;
        } else if( typeof obj[el] === 'object' && obj[el] !== null ) {
            return [...res, ...keyify(obj[el], prefix + el + '.')];
        } else {
            return [...res, prefix + el];
        }
    }, []);


function dotNotate(obj,target,prefix) {
    target = target || {},
        prefix = prefix || "";

    Object.keys(obj).forEach(function(key) {
        if ( typeof(obj[key]) === "object" ) {
            dotNotate(obj[key],target,prefix + key + ".");
        } else {
            return target[prefix + key] = obj[key];
        }
    });

    return target;
}

export const findDeep = (obj, find) => {
    const zip = dotNotate(obj);
    const array = [];
    Object.keys(zip).map((key) => {
        if(key.indexOf('.'+find) !== -1) {
            const path = key.split('.').slice(0, -1).join('.');
            const object = get(obj, path);
            if(object) {
                array.push(object);
            }
        }
    });
    return array
};

export const findDeepTypes = (obj, type) => {
    const zip = dotNotate(obj);
    const array = [];
    Object.keys(zip).map((key) => {
        const value = get(obj, key);
        if(typeof value === type) {
            array.push({value:value, key:key, group:key.split('.')[0]});
        }
    });
    return array
};


const clearAllDefaultData = (object) => {

    delete object.version_id;
    delete object.created_at;
    delete object.last_updated_at;
    //find and remove all keys with id or _id
    Object.keys(object).map(key => {
        if(key.includes('_id') || key === 'id') {
            delete object[key];
        }
    });

    // Search all nested arrays for ids
    Object.values(object).map(value => {
        // check if value is array
        if(Array.isArray(value)) {
            //check if has element && if first element is object
            if(value.length > 0 && value[0].constructor.name === "Object") {
                value.map( obj => {
                    clearAllDefaultData(obj);
                });
            }
        }
    } );
};

export const removeDefaultData = (object) => {
    const data = {...object};

    clearAllDefaultData(data);

    return data;
};

export const getProperty = (object, string) => {
    return string.split(".").reduce((o, i) => {
        if (o == null || o[i] == null) {
            return undefined;
        }
        return o[i];
    }, object);
};

export const operators = {
    eq: (leftvalue, rightvalue) => {
        return leftvalue === rightvalue;
    },
    ne: (leftvalue, rightvalue) => {
        return leftvalue !== rightvalue;
    },
    gt: (leftvalue, rightvalue) => {
        return leftvalue > rightvalue;
    },
    ge: (leftvalue, rightvalue) => {
        return leftvalue >= rightvalue;
    },
    le: (leftvalue, rightvalue) => {
        return leftvalue <= rightvalue;
    },
    lt: (leftvalue, rightvalue) => {
        return leftvalue < rightvalue;
    },
    between: (leftvalue, rightvalue) => {
        return leftvalue >= rightvalue[0] && leftvalue <= rightvalue[1];
    }
};

//Only works 1 shadowRoot deep
export const findElement = (element, selector) => {
    // If selector is in same as current element return it
    let cur = element.shadowRoot.querySelector(selector);
    if (cur) {
        return cur;
    }

    // Find all possible children of the element
    const possibleElements = element.shadowRoot.querySelectorAll(LIST_OF_INPUT_TAGS.join(","));
    if (possibleElements && possibleElements.length > 0) {
        let elmInShadowRoot;
        //check if selector is in shadowRoot of possible elements
        possibleElements.forEach(function (elm) {
            if (elm.shadowRoot.querySelector(selector)) {
                elmInShadowRoot = elm.shadowRoot.querySelector(selector);
            }
        });

        return elmInShadowRoot;
    }
};

export const findAllElement = (element, selector) => {
    // If selector is in same as current element return it
    let cur = element.shadowRoot.querySelectorAll(selector);
    if (cur && cur.length > 0) {
        return cur;
    }

    // Find all possible children of the element
    const possibleElements = element.shadowRoot.querySelectorAll(LIST_OF_INPUT_TAGS.join(","));
    if (possibleElements && possibleElements.length > 0) {
        let elmInShadowRoot;
        //check if selector is in shadowRoot of possible elements
        possibleElements.forEach(function (elm) {
            if (elm.shadowRoot.querySelector(selector) && elm.shadowRoot.querySelectorAll(selector).length > 0) {
                elmInShadowRoot = elm.shadowRoot.querySelectorAll(selector);
            }
        });

        return elmInShadowRoot;
    }
};

export const findHost = el => {
    if (el) {
        while (el.nodeType != 11) {
            el = el.parentNode;
        }
        return el;
    }
};

const collectionHas = (a, b) => {
    //helper function (see below)
    for (let i = 0, len = a.length; i < len; i++) {
        if (a[i] == b) return true;
    }
    return false;
};

export const findParentBySelector = (elm, selector) => {
    const all = document.querySelectorAll(selector);
    let cur = elm.parentNode ? elm.parentNode : elm;
    while (cur && !collectionHas(all, cur)) {
        //keep going up until you find a match
        cur = cur.parentNode; //go up
    }
    return cur; //will return null if not found
};

export const closestElement = (
    selector,      // selector like in .closest()
        base,   // extra functionality to skip a parent
        __Closest = (el, found = el && el.closest(selector)) =>
            !el || el === document || el === window
                ? null // standard .closest() returns null for non-found selectors also
                : found
                ? found // found a selector INside this element
                : __Closest(el.getRootNode().host) // recursion!! break out to parent DOM
) =>
{
    return __Closest(base);
}
;

export const findParent = (el, cls) => {
    if (el.classList.contains(cls)) {
        return el;
    }
    while ((el = el.parentElement) && !el.classList.contains(cls)) ;
    return el;
};

export const findParentDeep = (el, cls) => {
    if (el.classList.contains(cls)) {
        return el;
    }
    while ((el = el.parentElement) && !el.classList.contains(cls)) ;
    return el;
};
export const toggleOrderByElement = e => {
    let container = findParent(e.target, "order-by-container");
    let direction = e.target.dataset.direction;

    // Hide all tab-menu-items elements
    let orderByElements = container.querySelectorAll(".order-by");
    [].forEach.call(orderByElements, function (elm) {
        elm.setAttribute("data-direction", "");
    });

    if (direction == "asc") {
        e.target.setAttribute("data-direction", "desc");
    } else {
        e.target.setAttribute("data-direction", "asc");
    }
};

export const changeTab = e => {
    const target = e.target.dataset.target;
    let container = findParent(e.target, "tab-container");

    // Hide all tab-menu-items elements
    let tabMenuElements = container.querySelectorAll(".tab-menu-item");
    [].forEach.call(tabMenuElements, function (elm) {
        elm.classList.remove("active");
    });

    // Show clicked tab-item
    e.target.classList.add("active");

    // Show active tab-content and hide all other elements
    let tabContentElements = container.querySelectorAll(".tab-content-item");

    [].forEach.call(tabContentElements, function (elm) {
        if (elm.hasAttribute("data-tab-id") && elm.getAttribute("data-tab-id") === target) {
            elm.classList.add("active");
        } else {
            elm.classList.remove("active");
        }
    });
};

export const removeClass = (e, querySelector, className) => {
    let container = findHost(e.target);
    let elements = container.querySelectorAll(querySelector);
    [].forEach.call(elements, function (elm) {
        elm.classList.remove(className);
    });
};

export const toggleElement = (e, toggleStatus) => {
    let toggleButton;
    if (e.target.classList.contains("toggle-button")) {
        toggleButton = e.target;
    } else {
        toggleButton = findParent(e.target, "toggle-button");
    }
    if (!toggleButton) {
        console.error("toggle-button class not found on element");
        return;
    }
    const target = toggleButton.dataset.target;
    let container = findHost(e.target);
    let toggleElements = container.querySelectorAll(".toggle-element");
    if (!toggleElements.length > 0) {
        console.error("No element found with class toggle-element for toggleElement function");
        return;
    }
    if (!target) {
        console.error(
            "data-target not found. Element from which toggleElement is called doesnot have a data attribute data-target"
        );
        return;
    }
    let hasToggled = false;
    [].forEach.call(toggleElements, function (elm) {
        if (elm.hasAttribute("data-target-id") && elm.getAttribute("data-target-id") === target) {
            if (typeof toggleStatus === "undefined") {
                elm.classList.toggle("active");
            } else {
                if (toggleStatus) {
                    elm.classList.add("active");
                } else {
                    elm.classList.remove("active");
                }
            }
            hasToggled = true;
        }
    });
    if (hasToggled === false) {
        /* eslint-disable-next-line no-console */
        console.error("Not element found with data-target-id: " + target);
        return;
    }
};

const show = function (elem) {
    // Get the natural height of the element
    let getHeight = function () {
        elem.style.display = "block"; // Make it visible
        var height = elem.scrollHeight + "px"; // Get it's height
        elem.style.display = ""; //  Hide it again
        return height;
    };

    let height = getHeight(); // Get the natural height
    elem.classList.add("is-visible"); // Make the element visible
    elem.style.height = height; // Update the max-height

    // Once the transition is complete, remove the inline max-height so the content can scale responsively
    window.setTimeout(function () {
        elem.style.height = "";
    }, 350);
};

const hide = function (elem) {
    // Give the element a height to change from
    elem.style.height = elem.scrollHeight + "px";

    // Set the height back to 0
    window.setTimeout(function () {
        elem.style.height = "72px";
    }, 1);

    // When the transition is complete, hide it
    window.setTimeout(function () {
        elem.classList.remove("is-visible");
    }, 350);
};

export const toggleAccordionAnimated = e => {
    let parent = findParent(e.target, "accordion");

    // If the element is visible, hide it
    if (parent.classList.contains("is-visible")) {
        hide(parent);
        return;
    }

    // Otherwise, show it
    show(parent);
};

export const toggleAccordion = e => {
    let parent = findParent(e.target, "accordion");
    parent.classList.toggle("active");
};

export const changeAccordion = e => {
    let parent = findParent(e.target, "accordion");
    parent.classList.remove("active");
    let next = parent.nextElementSibling;
    next.classList.add("active");
};

export const valueByInputType = element => {
    let result;
    let type = element.type;
    let cast;

    if (element.dataset.cast) {
        if (type === "radio" || type === "checkbox") {
            cast = element.dataset.cast;
        } else {
            type = element.dataset.cast;
        }
    }

    if (type && type === "file") {
        result = element.value;
    }
    if (type && type === "text") {
        result = element.value;
    } else if (type && type === "number") {
        if (element.step) {
            result = parseFloat(element.value);
        } else {
            result = parseInt(element.value);
        }
    } else if (type && type === "date") {
        if (element.value) {
            result = new Date(element.value);
        } else {
            result = null;
        }
    } else if (type && type === "radio") {
        if (element.checked) {
            if (cast === "number") {
                result = parseInt(element.value);
            } else {
                result = element.value;
            }
        } else {
            result = null;
        }
    } else if (type && type === "checkbox") {
        if (element.name.includes("[]")) {
            if (element.checked) {
                if (cast === "number") {
                    result = parseInt(element.value);
                } else {
                    result = element.value;
                }
            } else {
                result = null;
            }
        } else {
            if (cast === "number") {
                result = parseInt(element.value);
            } else {
                result = element.checked;
            }
        }
    } else if (type && type === "json") {
        result = JSON.parse(element.value);
    } else {
        result = element.value;
    }
    return result;
};

export const textToSlug = string => {
    if (!string) {
        return;
    }
    const a = "àáäâãåăæąçćčđďèéěėëêęğǵḧìíïîįłḿǹńňñòóöôœøṕŕřßşśšșťțùúüûǘůűūųẃẍÿýźžż·/_,:;";
    const b = "aaaaaaaaacccddeeeeeeegghiiiiilmnnnnooooooprrsssssttuuuuuuuuuwxyyzzz------";
    const p = new RegExp(a.split("").join("|"), "g");

    return string
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w\-]+/g, "") // Remove all non-word characters
        .replace(/\-\-+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text
};

export const slugToTitle = (slug) => {
    const words = slug.split("-");
    return words.map(function (word) {
        return word.charAt(0).toUpperCase() + word.substring(1).toLowerCase();
    }).join(' ');
};

Object.compare = function (obj1, obj2, ignoreNull) {
    //Loop through properties in object 1
    for (var p in obj1) {
        //Check property exists on both objects
        if (obj1.hasOwnProperty(p) !== obj2.hasOwnProperty(p)) return false;

        switch (typeof obj1[p]) {
            //Deep compare objects
            case "object":
                if (!Object.compare(obj1[p], obj2[p])) return false;
                break;
            //Compare function code
            case "function":
                if (typeof obj2[p] == "undefined" || (p != "compare" && obj1[p].toString() != obj2[p].toString()))
                    return false;
                break;
            //Compare values
            default:
                if (obj1[p] != obj2[p]) return false;
        }
    }
    //Check object 2 for any extra properties
    if (!ignoreNull) {
        for (var p in obj2) {
            if (typeof obj1[p] == "undefined") return false;
        }
    }
    return true;
};
